<template>
  <div>
    <details>
      <summary>Pending Requested Samples</summary>
      <table class="table table-hover">
        <thead class="blue-gradient white-text">
        <tr>
          <th scope="col"><em><b>ID</b></em></th>
          <th scope="col"><em><b>REQUESTER</b></em></th>
          <th scope="col"><em><b>PROJECT</b></em></th>
          <th scope="col"><em><b>SAMPLE CODE</b></em></th>
          <th scope="col"><em><b>REQUEST DATE</b></em></th>
          <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
          <th scope="col"><em><b>RESPOND</b></em></th>
          <th scope="col"><em><b>ACTIONS</b></em></th>
        </tr>
        </thead>
        <tbody>
        <tr :key="requested.id" v-for="(requested, index) in pending_requested_samples">
          <td> {{ index + 1 }}</td>
          <td v-if="requested.requester"> {{ requested.requester }}</td>
          <td v-else> N/A</td>
          <td v-if="requested.project"> {{ requested.project }}</td>
          <td v-else> N/A</td>
          <td v-if="requested.sample_code"> {{ requested.sample_code }}</td>
          <td v-else> N/A</td>
          <td v-if="requested.request_date"> {{ requested.request_date }}</td>
          <td v-else> N/A</td>
          <td v-if="requested.amount"> {{ requested.amount }}</td>
          <td v-else> N/A</td>
          <td>
            <approved-amount-switch :index="index" :item="pending_requested_samples[index]">
            </approved-amount-switch>
          </td>
          &nbsp; <b-icon
              @click="viewMyRequestedSamples(requested)"
              class="border border-info rounded"
              :font-scale="`${font_scale}`" icon="eye-fill"
              title="View"
              v-b-modal.modal-requested-sample-view
              v-b-tooltip.hover variant="info"
          ></b-icon>
          &nbsp;
          &nbsp; <b-icon
              @click="setRequestCode(requested.code)"
              class="border border-info rounded"
              :font-scale="`${font_scale}`"
              icon="pencil" title="Update"
              v-b-modal.modal-requested-sample v-b-tooltip.hover
              variant="info"
          ></b-icon>
        </tr>
        </tbody>
      </table>

      <!-- REQUEST VIEW -->
      <b-modal
          id="modal-requested-sample-view"
          title="About Sample Request"
          v-model="showModalViewResponse"
      >
        <p><em>Project:</em> {{ requested.project }}</p>
        <p><em>Requester:</em> {{ requested.requester }}</p>
        <p><em>Sample Type:</em> {{ requested.type }}</p>
        <p><em>Sample Species:</em> {{ requested.species }}</p>
        <p><em>Requested Amount:</em> {{ requested.amount }}</p>
        <p><em>Request Date:</em> {{ requested.request_date }}</p>
        <p><em>Response Date:</em> {{ requested.response_date }}</p>
        <p><em>Request Status:</em> {{ requested.status }}</p>

        <template v-slot:modal-footer="{ ok, cancel, hide }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button @click="cancel()" size="md" variant="danger">
            Cancel
          </b-button>
          <div v-if="requested.status === 'PENDING'">
            <b-button @click="showModalUpdateResponse = !showModalUpdateResponse" size="md" variant="primary">
              Update
            </b-button>
          </div>

          <div v-else>
            <b-button disabled size="md" variant="primary"> Update</b-button>
          </div>
        </template>
      </b-modal>

      <!-- REQUEST UPDATED -->
      <b-modal
          cancel-variant="danger"
          hide-footer
          id="modal-requested-sample"
          title="Respond To Sample Request"
          v-model="showModalUpdateResponse"
          @shown="sendRequestCodeToParent"
      >
        <SampleResponseForm></SampleResponseForm>
      </b-modal>

      <!-- COMPLETE REQUEST BUTTON  -->
      <div class="d-flex justify-content-end" v-if="pending_requested_samples.length !== 0">
        <b-button size="md" variant="primary" style="border-radius: 50%"
                  v-b-modal.modal-sample-request
                  @click="respondToBatchRequest(pending_requested_samples, self)">
          Respond</b-button>
      </div>
    </details>
  </div>
</template>

<script>
import SampleResponseForm from "@/components/SampleResponseForm";
import {font_scale} from "@/utils/constants";
import EventBus from "@/components/EventBus";
import {
  getUserDashboardInfo, respondToBatchRequest,
} from "@/utils/util_functions";
import ApprovedAmountSwitch from "@/components/ApprovedAmountSwitch";
// import {batch_sample_response_resource} from '@/utils/api_paths';
// import BatchSampleRequestResponse from "@/pages/SampleRequest/BatchSampleRequestResponse";
// import BatchSampleRequestResponse from '@/pages/SampleRequest/BatchSampleRequestResponse';

export default {
  name: "UserRequestedSamples",
  components: {ApprovedAmountSwitch, SampleResponseForm},

  data(){
    return{
      time: 2000,
      font_scale,
      response: {},
      requested: {},
      requestCode: null,
      pending_requested_samples: [],
      showModalViewResponse: false,
      showModalUpdateResponse: false,
      self: this,
    }
  },

  mounted() {
    EventBus.$on('created-user-dashboard', ()=> {
      this.response = getUserDashboardInfo()
      this.pending_requested_samples = this.response.pending_requested_samples

    })

    EventBus.$on('close-modal', (payload)=>{
      this.showModalUpdateResponse = payload
    })

    EventBus.$on('new-div-data', payload => {
      let index = payload['index']
      if (this.pending_requested_samples[index] !== undefined){
        this.pending_requested_samples[index].approved = payload['cellValue']

        if (this.pending_requested_samples[index].approved > this.pending_requested_samples[index].amount){
          this.pending_requested_samples[index].approved = 0

          // set error on the div
          document.getElementById('input_'+index).textContent = 'value is greater than available amount';
          document.getElementById('input_'+index).style.backgroundColor = 'red';
        }

      }
      this.$log.info('new sample-request ', this.pending_requested_samples[index])
    })
  },

  methods: {
    respondToBatchRequest,
    setRequestCode(code) {
      this.showModalUpdateResponse = !this.showModalUpdateResponse
      this.requestCode = code
    },

    sendRequestCodeToParent(){
      this.$log.info('sendRequestCodeToParent called')
      EventBus.$emit('request-code', this.requestCode)
    },

    viewMyRequestedSamples(requested) {
      this.showModalViewResponse = !this.showModalViewResponse
      this.requested = requested
    },
  },
}
</script>
